import API from 'types/api';
import APP from 'types/app';
import _ from 'lodash';

const initialState = {
  isLoading: false,
  isError: false, // ошибка в запросе самом
  errors: null, // апи вернул ошибки (например валидация),
  message: '', // field for data.status.message
  isPhoneValidation: false,
  isSuccess: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case API.POST_REGISTRATION_FETCH:
      return {
        ...state,
        isLoading: true,
        isError: false,
        errors: null,
      };
    case API.POST_REGISTRATION_SUCCESS:
      if (_.get(payload, 'status.completion') === 'complete') {
        return {
          ...state,
          isLoading: false,
          isError: false,
          errors: null,
          message: _.get(payload, 'status.message', ''),
          isPhoneValidation: false,
          isSuccess: true,
        };
      } else if (
        _.get(payload, 'status.completion') === 'incomplete' &&
        _.get(payload, 'status.proceed_to') === 'phone_verification'
      ) {
        return {
          ...state,
          isLoading: false,
          isError: false,
          errors: null,
          message: _.get(payload, 'status.message', ''),
          isPhoneValidation: true,
          isSuccess: false,
        };
      }
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: null,
        message: _.get(payload, 'status.message', ''),
        isPhoneValidation: false,
        isSuccess: false,
      };
    case API.POST_REGISTRATION_ERROR:
      if (payload.code === 200) {
        // ошибка валидации
        if (_.get(payload, 'response.errors.0.code') === 'sms.verification_code.not_match') {
          payload.response.errors[0].field = 'login';
        }
        return {
          ...state,
          isLoading: false,
          isError: false,
          errors: payload.response.errors,
        };
      }
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: null,
      };
    case APP.RESET_SERVICE_API_DATA:
      if (payload === 'registration') {
        return {
          ...initialState,
        };
      }
      return state;
    case APP.REMOVE_API_RESPONSE_ERROR:
      if (payload.type === 'registration' && _.isArray(state.errors) && state.errors.length > 0) {
        return {
          ...state,
          errors: state.errors.reduce((prev, item) => {
            if (item.field !== payload.field) {
              prev.push(item);
            }
            return prev;
          }, []),
        };
      }
      return state;
    default:
      return state;
  }
};
